import { useState } from "react";
import { sendContact } from "../api";

const FB = "https://www.facebook.com/profile.php?id=61567252557995";
const IG = "https://www.instagram.com/akimart766/";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [status, setStatus] = useState({ type: "", text: "" });
  const [sending, setSending] = useState(false);

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setStatus({ type: "", text: "" });
    try {
      const data = await sendContact(form);
      setStatus({ type: "ok", text: data?.message || "Message sent. We’ll be in touch soon." });
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      setStatus({ type: "err", text: err.message || "Could not send message." });
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <div className="page-hero">
        <div className="container">
          <h1>Visit Aki Mart</h1>
          <p>Your Habesha market in Lilburn — come for injera, stay for community.</p>
        </div>
      </div>

      <div className="container contact-grid">
        <div className="contact-card">
          <h2>Store details</h2>
          <p className="label">Address</p>
          <p>
            1025 Killian Hill Rd
            <br />
            Lilburn GA, 30047 Suite C
          </p>
          <p className="label">Phone</p>
          <p>
            <a href="tel:+14044536512">+1 (404) 453-6512</a>
          </p>
          <p className="label">Email</p>
          <p>
            <a href="mailto:aschalew@akismart.com">aschalew@akismart.com</a>
          </p>
          <p className="label">Social</p>
          <div className="social-row">
            <a className="social-link" href={FB} target="_blank" rel="noreferrer">
              Facebook
            </a>
            <a className="social-link" href={IG} target="_blank" rel="noreferrer">
              Instagram
            </a>
          </div>
          <p className="contact-blurb">
            Order online for pickup, or stop by for fresh injera, dabo, roasted kolos, and handmade
            Habesha dresses.
          </p>
        </div>

        <form className="contact-form" onSubmit={onSubmit} noValidate>
          <h2>Send a message</h2>
          <p className="contact-form-lead">Questions about orders, catering, or pickup? Write us here.</p>

          <label htmlFor="contact-name">Name</label>
          <input
            id="contact-name"
            name="name"
            type="text"
            required
            autoComplete="name"
            value={form.name}
            onChange={onChange}
          />

          <label htmlFor="contact-email">Email</label>
          <input
            id="contact-email"
            name="email"
            type="email"
            required
            autoComplete="email"
            value={form.email}
            onChange={onChange}
          />

          <label htmlFor="contact-phone">Phone <span className="optional">(optional)</span></label>
          <input
            id="contact-phone"
            name="phone"
            type="tel"
            autoComplete="tel"
            value={form.phone}
            onChange={onChange}
          />

          <label htmlFor="contact-message">Message</label>
          <textarea
            id="contact-message"
            name="message"
            rows={5}
            required
            value={form.message}
            onChange={onChange}
          />

          {status.text && (
            <p className={`form-status ${status.type === "ok" ? "is-ok" : "is-err"}`} role="status">
              {status.text}
            </p>
          )}

          <button className="btn btn-primary" type="submit" disabled={sending}>
            {sending ? "Sending…" : "Send message"}
          </button>
        </form>
      </div>

      <div className="container" style={{ paddingBottom: "4rem" }}>
        <div className="map-embed">
          <iframe
            title="Aki Mart location map"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            src="https://maps.google.com/maps?q=1025%20Killian%20Hill%20Rd%20Lilburn%20GA%2030047&t=&z=15&ie=UTF8&iwloc=&output=embed"
          />
        </div>
      </div>
    </>
  );
}
